import { ProductDocument } from '@models/product';
import { getProductSlug } from '@util/urlHelpers';
import { useRouter } from 'next/navigation';
import React from 'react';

const ListingActionButtons = ({
  variant,
  product,
  saveDraft,
  onSubmitClick,
  isLoading,
  isDraft = false,
}: {
  variant?: 'edit-listing' | 'create-listing';
  product?: ProductDocument | null;
  saveDraft: () => void;
  onSubmitClick: () => void;
  isLoading?: boolean;
  isDraft?: boolean;
}) => {
  const router = useRouter();

  return (
    <div className="flex w-full flex-col items-center justify-normal gap-8 whitespace-nowrap">
      <button
        onClick={() => {
          if (variant === 'edit-listing' && product) {
            router.push(getProductSlug(product));
          } else {
            router.back();
          }
        }}
        className="flex w-full items-center justify-center gap-x-2 rounded-[1.5rem] bg-brand-lightest-gray px-8 py-4 text-[1.8rem] text-black sm:w-[25rem]"
        type="button"
        disabled={isLoading}
      >
        Back
      </button>
      {variant === 'edit-listing' ? (
        <>
          {product?.is_draft && (
            <button
              onClick={saveDraft}
              className=" flex w-full grow items-center justify-center gap-x-2 rounded-[1.5rem] bg-brand-lightest-gray px-8 py-4 text-[1.8rem] text-black sm:w-[25rem] sm:grow-0"
              type="button"
              disabled={isLoading}
            >
              {isLoading ? 'Updating...' : 'Update Draft'}
            </button>
          )}
          <button
            onClick={onSubmitClick}
            disabled={
              product?.integration_info?.type === 'shopify' ||
              product?.integration_info?.type === 'ebay' ||
              isLoading
            }
            className="flex w-full items-center justify-center gap-x-2 rounded-[1.5rem] bg-brand-secondary px-8 py-4 text-[1.8rem] text-white disabled:cursor-not-allowed disabled:opacity-50 sm:w-[25rem]"
            type="button"
          >
            {isLoading
              ? 'Processing...'
              : product?.is_draft
              ? 'Publish Item'
              : 'Save Changes'}
          </button>
        </>
      ) : (
        <>
          <button
            onClick={saveDraft}
            className="flex w-full grow items-center justify-center gap-x-2 rounded-[1.5rem] border-[1px] border-black bg-white px-8 py-4 text-[1.8rem] text-black sm:w-[25rem] sm:grow-0"
            type="button"
            disabled={isLoading}
          >
            {isLoading
              ? 'Saving...'
              : isDraft
              ? 'Update Draft'
              : 'Save As Draft'}
          </button>
          <button
            type="button"
            onClick={onSubmitClick}
            className=" flex w-full grow items-center justify-center gap-x-2 rounded-[1.5rem]  bg-brand-secondary px-8 py-4 text-[1.8rem] text-white sm:w-[25rem] sm:grow-0"
            disabled={isLoading}
          >
            {isLoading ? 'Publishing...' : 'Publish Listing'}
          </button>
        </>
      )}
    </div>
  );
};

export default ListingActionButtons;
